import { Controller } from '@hotwired/stimulus';

const BOOKING_NUMBER_PATTERN = /^b[a-z]{2}\d{2}\d+$/;
const STRUCTURAL_TOO_LONG_PATTERN = /^(?:-+|.*--.*|-{2,}$)/;

export default class extends Controller {
  static targets = ['input', 'warnings'];

  static values = {
    publicIdLength: Number,
    charset: String,
    messages: Object,
  };

  connect() {
    this.validate();
  }

  validate() {
    const query = this.inputTarget.value.trim();
    const warningMessages = this.warningsFor(query);

    this.warningsTarget.replaceChildren();
    if (warningMessages.length === 0) {
      this.warningsTarget.hidden = true;
      return;
    }

    warningMessages.forEach((message) => {
      const aside = document.createElement('aside');
      aside.className = 'staff-info-box staff-info-box--warning';
      aside.setAttribute('role', 'alert');

      const paragraph = document.createElement('p');
      paragraph.textContent = message;
      aside.appendChild(paragraph);

      this.warningsTarget.appendChild(aside);
    });
    this.warningsTarget.hidden = false;
  }

  warningsFor(query) {
    if (!query) return [];

    const trimmed = query.trim();
    const warnings = [];

    if (STRUCTURAL_TOO_LONG_PATTERN.test(trimmed)) {
      warnings.push(this.messagesValue.too_long);
    }

    const canonical = this.canonicalQuery(trimmed);

    if (BOOKING_NUMBER_PATTERN.test(canonical)) return warnings;

    if (!this.isValidPublicIdChars(canonical)) {
      warnings.push(this.messagesValue.invalid_chars);
    } else if (this.isCompletePublicId(canonical) || this.isPartialPublicId(canonical)) {
      return warnings;
    }

    if (canonical.length > this.publicIdLengthValue && !warnings.includes(this.messagesValue.too_long)) {
      warnings.push(this.messagesValue.too_long);
    }

    return warnings;
  }

  canonicalQuery(query) {
    const normalized = query.trim().replace(/(?<=[A-Za-z0-9])-(?=[A-Za-z0-9])/g, '');

    return normalized.replace(/-/g, '').toLowerCase();
  }

  isValidPublicIdChars(canonical) {
    return new RegExp(`^[${this.charsetValue}]+$`).test(canonical);
  }

  isCompletePublicId(canonical) {
    return canonical.length === this.publicIdLengthValue && this.isValidPublicIdChars(canonical);
  }

  isPartialPublicId(canonical) {
    return (
      canonical.length >= 1 &&
      canonical.length < this.publicIdLengthValue &&
      this.isValidPublicIdChars(canonical)
    );
  }
}
